export const movie_ee_json_csv = {
    entityName: "",
    entityCategory: "movie",
    displayImageUrl: "",
    //weightage: 0,
    triviaCard: {
        director: "",
        ytUrl: "",
        leadCast: "",
        releaseDate: "",
        yearOfRelease: "",
        genre: "",
        language: "",
        producer: "",
        productionHouse: "",
        writer: "",
        history: {
            history1: {
                name: "",
                collection: "",
                association: ""
            },
            history2: {
                name: "",
                collection: "",
                association: ""
            },
            history3: {
                name: "",
                collection: "",
                association: ""
            }
        }
    }
};

export const song_ee_json_csv = {
    entityName: "",
    entityCategory: "song",
    displayImageUrl: "",
    //weightage: "",
    triviaCard: {
        musicDirector: "",
        movie: "",
        ytUrl: "",
        title: "",
        album: "",
        singers: "",
        composer: "",
        musicDirector: "",
        lyricist: "",
        yearOfRelease: "",
        last3releasesAverageStreams: "",
        currentNumberofStreams: "",
        positionOnTheplaylist: "",
        spotifyStats: "",
        mostPopularSongs: ""
    }
};

export const video_ee_json_csv = {
    entityName: "",
    entityCategory: "video",
    displayImageUrl: "",
   //weightage: "",
    triviaCard: {
        title: "",
        creatorName: "",
        channelName: "",
        releaseDate: "",
        genre: "",
        artists: "",
        ytUrl: "",
        trendingListPosition: "",
        totalViews: "",
        totalChannelSubscribers: ""
    }
};

export const reel_ee_json_csv = {
    entityName: "",
    entityCategory: "reel",
    displayImageUrl: "",
    //weightage: "",
    triviaCard: {
        creatorName: "",
        datePosted: "",
        genre: "",
        HashTags: "",
        ytUrl: "",
        totalFollowers: "",
        likesOfTheLastReel: "",
        commentsOnTheLastReel: "",
    }
};

export const influencers_ee_json_csv = {
    entityName: "",
    entityCategory: "influencer",
    displayImageUrl: "",
    //weightage: "",
    triviaCard: {
        ytUrl: "",
        name: "",
        platform: "",
        genre: "",
        activeSince: "",
        totalFollowers: "",
        dateOfLastPost: "",
        totalLikesOnLastPost: "",
        commentsOnLastPost: "",
    }
};

export const music_director_ee_json_csv = {
    entityName: "",
    entityCategory: "music_director",
    displayImageUrl: "",
    //weightage: "",
    triviaCard: {
        debutMovie: "",
        milestoneMovies: "",
        dateOfBirth: "",
        debutYear: "",
    }
};

export const cricketer_ee_json_csv = {
    entityName: "",
    entityCategory: "cricketer",
    displayImageUrl: "",
    //weightage: "",
    triviaCard: {
        dateOfBirth: "",
        matches: "",
        runs: "",
        wickets: "",
    }
};

export const actor_ee_json_csv = {
    entityName: "",
    entityCategory: "actor",
    displayImageUrl: "",
    //weightage: "",
    triviaCard: {
        dateOfBirth: "",
        debutMovie: "",
        debutYear: "",
        milestoneMovies: "",
    }
};

export const actoress_ee_json_csv = {
    entityName: "",
    entityCategory: "actoress",
    displayImageUrl: "",
    //weightage: "",
    triviaCard: {
        dateOfBirth: "",
        debutMovie: "",
        debutYear: "",
        milestoneMovies: "",
    }
};

export const default_ee_json_csv = {
    entityName: "",
    entityCategory: "",
    displayImageUrl: "",
    content_tag: [],
    location_tag: [],
    language_tag: [],
    //weightage: "",
};

export const rap_housie_game_csv = {
    duration: "",  // in second
    theme: "",
    videoUrl: "",
    cloudFlareVideoId: "",
    content_tag: [],
    location_tag: [],
    language_tag: [],
    timeLine: []
};

export const rap_housie_game_csv_timeline = {
    time: "", // in second
    entityName: "",
    entityCategory: "",
    displayImageUrl: ""
};

export const rap_real_fantasy_league_game_csv = {
    title: "RapLeague",
    subTitle: "RapLeague",
    banner: "",
    goLiveAt: 1758315644000,
    gameTheme: "basic",
    team01:"",
    team02:"",
    matchTime:1758315644000,
    submissionCutOffAt: 1758315644000,  //12 hours after goLiveAt
    resultDeclarationAt: 1758315644000, //72 hours after submissionCutOffAt
    sponser: {
        name: "",
        banner: ""
    },
    media: [],
};

export const rap_real_fantasy_league_game_csv_multimedia = {
    entityName: "",
    entityCategory: "",
    displayImageUrl: ""
};

export const rap_real_fantasy_league_game_stats_csv = {
    entities: [

    ]
};

export const rap_real_fantasy_league_game_stats_csv_movie = {
    entityId: "",
    name: "",
    category: "",
    collection: 0
};

export const rap_real_fantasy_league_game_stats_csv_song = {
    entityId: "",
    name: "",
    category: "",
    count: 0,
    pos: 0
};

export const rap_real_fantasy_league_game_stats_csv_video = {
    entityId: "",
    name: "",
    category: "",
    view: 0
};

export const rap_real_fantasy_league_game_stats_csv_reel = {
    entityId: "",
    name: "",
    category: "",
    view: 0,
    comment: 0,
    share: 0
};

export const rap_real_fantasy_league_game_stats_csv_influencers = {
    entityId: "",
    name: "",
    category: "",
    view: 0,
    follower: 0,
    upload: 0
};

export const rap_real_fantasy_league_game_stats_csv_batsman = {
    entityId: "",
    name: "",
    category: "",
    runs: 0,
    strikeRate: 0
};

export const rap_real_fantasy_league_game_stats_csv_bowler = {
    entityId: "",
    name: "",
    category: "",
    wickets: 0,
    economyRate: 0
};

export const rap_real_fantasy_league_game_stats_csv_allRounder = {
    entityId: "",
    name: "",
    category: "",
    wickets: 0,
    runs: 0
};

export const question_bank_multimedia_csv = {
    contentId: "",
    form: "",
    type: "",
    url: "",
    aspectRatio: "",
    //entity: [], //question_bank_entity_csv
};

export const question_bank_entity_csv = {
    id: "",
    type: "",
}

export const question_bank_option_multimedia_csv = {
    url: "",
    form: "",
    type: "",
}

export const question_bank_option_csv = {
    text: "",
    label: "",
    multimedia: question_bank_option_multimedia_csv,
}

export const question_bank_csv = {
    csv_questionId: "",
    questionCategory: "",
    contentId: "",
    difficulty: "",
    entityName: "",
    entityType: "",
    csv_tags: [],   //string
    gameType: "",
    questionText: "",
    answer: "",
    multimedia: question_bank_multimedia_csv,
    options: [],    // question_bank_option_csv
};

export const question_bank_2_csv = {
    contentId: "",
    entityName: "",
    entityType: "",
    questionText: "",
    answer: "",
    options: "",    // question_bank_option_csv
    difficulty: -1,
    gameType: [],
    content_tag: [],
    location_tag: [],
    language_tag: [],
};

const excludedKeys = ["triviaCard", "common", "housie", "fantasy", "transient"];

export const entity_vimeo_playable_URL_csv = {
    ContentID: "",
    ContentURL: "",
    vimeoNonPlayableURL: "",
    vimeoPlayableURL: "",
    duration: "",
    previewImage:""
};

export const unknown_content_id_mapping_csv = {
    contentId: "",
    form: "",
    newForm: "",
    type: "",
    url: "",
    aspectRatio: "16:9",
};

function getAllKeysWithFullPath(obj, prefix = "") {
    let keys = [];
    for (let key in obj) {
        const fullKey = prefix ? `${prefix}.${key}` : key;
        keys.push(fullKey);
        if (obj[key] && typeof obj[key] === "object" && !Array.isArray(obj[key])) {
            keys = keys.concat(getAllKeys(obj[key], fullKey));
        }
    }
    return keys;
}
//const allKeysWithFullPath = getAllKeysWithFullPath(data);
//console.log(allKeysWithFullPath);



function getAllKeysExcludeSomeKeys(obj) {
    let keys = [];
    for (let key in obj) {
        if (excludedKeys.includes(key)) continue;
        keys.push(key);
        if (obj[key] && typeof obj[key] === "object" && !Array.isArray(obj[key])) {
            keys = keys.concat(getAllKeys(obj[key]));
        }
    }
    return keys;
}
//const allKeysExcludeSomeKeys = getAllKeysExcludeSomeKeys(data);
//console.log(allKeysExcludeSomeKeys);



function getAllKeys(obj) {
    let keys = [];
    for (let key in obj) {
        keys.push(key);
        if (obj[key] && typeof obj[key] === "object" && !Array.isArray(obj[key])) {
            keys = keys.concat(getAllKeys(obj[key]));
        }
    }
    return keys;
}
//const allKeys = getAllKeys(data);
//console.log(allKeys);


export const formatDateTime = (isoString) => {
    if (!isoString) return "-";

    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    // Format hours and minutes with AM/PM
    const time = date.toLocaleTimeString('en-IN', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });

    return `${day}/${month}/${year} : ${time}`;
};

export function timestampToMilliseconds(timestamp) {
    // timestamp format: "DD/MM/YYYY HH:mm"
    const [datePart, timePart] = timestamp.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [hours, minutes] = timePart.split(':').map(Number);

    const date = new Date(year, month - 1, day, hours, minutes);
    console.log("Converted Date:", date);
    return date.getTime(); // milliseconds since Unix epoch
}

export function timestampToMilliseconds2(timestamp) {
    // timestamp format: "DD/MM/YYYY HH:mm" or "DD/MM/YY HH:mm"
    const [datePart, timePart] = timestamp.split(' ');
    const [day, month, yearRaw] = datePart.split('/').map(Number);
    let year = yearRaw;
    if (year < 100) year += 2000; // treat 2-digit years as 20xx
    const [hours, minutes] = timePart.split(':').map(Number);

    const date = new Date(year, month - 1, day, hours, minutes);
    console.log("Converted Date:", date);
    return date.getTime(); // milliseconds since Unix epoch
}

export function millisecondsToTimestamp(ms) {
    const date = new Date(ms);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
}